export function Privacy() {
  return (
    <main className="max-w-3xl mx-auto px-6 sm:px-10 py-16">
      <p className="label-overline">Plain words on private matters</p>
      <h1 className="font-display text-5xl mt-2 mb-6">Privacy</h1>
      <div className="space-y-5 font-body text-ink-iron leading-relaxed">
        <p>We collect only what is necessary to introduce hermits to hosts: your email, your name, the words you compose for your profile, and the letters you send. Payment information is handled by Stripe; we never see your card.</p>
        <p>We do not sell your data. We do not advertise to you. We will use your email only to send relevant letters about your account, your applications, and rare announcements.</p>
        <p>You may delete your account at any time by writing to <a className="text-wax-red hover:underline" href="mailto:hello@hearthandhermit.com">hello@hearthandhermit.com</a>.</p>
      </div>
    </main>
  );
}

export function Terms() {
  return (
    <main className="max-w-3xl mx-auto px-6 sm:px-10 py-16">
      <p className="label-overline">A simple compact</p>
      <h1 className="font-display text-5xl mt-2 mb-6">Terms</h1>
      <div className="space-y-5 font-body text-ink-iron leading-relaxed">
        <p>Hearth &amp; Hermit is a discovery service. We do not draft, witness, or enforce the agreements you make with one another. The arrangement of a hermitage is, in the spirit of the practice, between you, the host, and the land.</p>
        <p>Be honest. Be safe. Verify identities before exchanging keys or money. We strongly recommend a written contract for any arrangement that involves residence.</p>
        <p>You agree not to use the service to harass others or to misrepresent yourself or your property.</p>
        <p>Subscription fees are billed by Stripe. Cancel any time. No refunds for partial periods.</p>
      </div>
    </main>
  );
}
